import React from 'react';
import '../App.css';

function FoundersPage() {
    return (
      <div class="home-container">
        <div class="card1">
            <div class="title">Founder's Page</div>
           <h5>About Us</h5>
          <p class="p2">Welcome to the Yoga Hanuman Society (YHT), a sanctuary of spiritual growth, cultural enrichment, and heartfelt 
            community in the heart of the Lower Mainland. Our temple is more than just a place of worship, it is a home where every soul 
            is celebrated, every tradition honored, and every visitor warmly embraced.</p>
            <h5>Our Origin</h5>
          <p class="p2">The Yoga Hanuman Society was founded by the compassionate and inspiring Ram Shakthi, lovingly known to all as ‘Panditji.’ 
            Guided by a simple yet profound mission to offer an authentic, pure, and uplifting spiritual experience to devotees, Panditji dedicated 
            his life to making accessible the blessings and teachings of Anchaneya (Hanumanji).</p>
          <p class="p2">His journey of service began over 18 years ago in Montreal and deepened through years of devotion in Richmond before 
            realizing his true calling—to establish a temple where unwavering service, community spirit, and the essence of hanuman bhakti 
            could flourish. With tireless hands and a joyful heart, Panditji personally adorned every corner of our temple, sourcing sacred idols 
            from India and creating a space designed to nurture peace, joy, and devotion in every visitor.</p>
            <h5>A Journey of Welcome and Belonging</h5>
          <p class="p2">The moment you step into the Yoga Hanuman Temple, you are greeted not just as a guest, but as family. Our dedicated volunteers
             welcome you with warmth, kindness, and an open heart, ensuring everyone feels at home, no matter their background or experience. This spirit
              of inclusivity is the cornerstone of what we do.</p>
          <p class="p2">Panditji’s pooja ceremonies are renowned for theirdevotion, musicality, and soul-stirring energy, reminiscent of the great South 
            Indian temples. His vibrant hymns, passionate chanting, and unwavering attention to detail transport devotees, inspiring a deep connection 
            with Hanumanji.</p>
            <h5>Embracing Peace and Culture</h5>
          <p class="p2">Our sanctuary is more than a place to pray - it is a space to find inner peace and calm. When services are not in session, we invite
             everyone to take a moment to sit quietly, absorb the serene surroundings, and chant Anchaneya’s name in personal reflection. Families, especially
              parents with young children, are encouraged to cultivate mindful silence and instill peaceful habits and spiritual values from an early age.</p>
              <h5>Building Our Future, Together</h5>
          <p class="p2">The YHT committee is devoted to a bright vision: securing land to build a permanent temple—a lasting beacon of light for generations to 
            come. Thanks to the unwavering generosity of our patrons, we have already made great strides, but our journey continues.</p>
        </div>
      {/* Add page content */}
      
    </div>
  );
};

export default FoundersPage;